<script setup lang="ts">
import { telegramLink } from 'src/data/contacts';
</script>

<template lang="pug">
a.telegram-link(:href="telegramLink").no-underline.text-size-24px.lg-text-size-28px
  | Telegram
</template>
